module.exports = __webpack_public_path__ + "img/T6-D-xh_6.f3868ec3.png";